import React, { useState, useEffect } from "react";

/** Components */
import {
  TableContainer,
  TableHead,
  TextField,
  TableRow,
  TableCell,
  TableBody,
  Table,
  Paper,
  TablePagination,
  Button,
  Checkbox,
  ButtonGroup,
  TableFooter,
  Collapse,
  Autocomplete,
  Tooltip,
} from "@mui/material";
import LoadingProgress from "../../commons/LoadingProgress.component";
import CustomDatePicker from "../../commons/CustomDatePicker";
import { FilterBy } from "../../commons/filter.component";
import SelectStatusButton, { statusOptions } from "../../commons/SelectStatusButton";
import ButtonWithAPICall from "../../commons/ButtonWithAPICall.component";

/** Icons */
import SearchIcon from "@mui/icons-material/Search";
import RefreshIcon from "@mui/icons-material/Refresh";

/** Api & Function */
import { getCustomers, getSaleOrder, postSync, updateSaleOrderStatus } from "../../../services/api";
import { setHeaderTitle } from "../../../store/layoutSlide";
import { convertInvoiceType } from "../../../services/libService";

/** Package */
import moment from "moment";
import { useTranslation } from "react-i18next";

/** Hook */
import { useSelector, useDispatch } from "react-redux";
import { setDataFromBEState } from "../../../store/dataFromBESlice";

const initialFilter = {
  id: "",
  customer: null,
  so_no: "",
  effect_date: "",
  exp_date: "",
  status: null,
};
const SaleOrder = () => {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const data = useSelector((state) => state.data.saleOrder);
  const [changeIds, setChangeIds] = useState([]); //ids cua nhung sale order can cap nhat
  //filter
  const [filter, setFilter] = useState({ ...initialFilter });
  const [isOpen, setOpen] = useState(false);
  ////////

  useEffect(() => {
    dispatch(setHeaderTitle("THÔNG TIN ĐƠN BÁN HÀNG"));
    if (!data)
      getSaleOrder().then((res) => {
        res.code === 200 && dispatch(setDataFromBEState({ saleOrder: res.data }));
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    setPage(0);
  }, [filter]);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleCheckBoxClick = (id) => {
    if (changeIds.includes(id)) setChangeIds((prev) => prev.filter((item) => item !== id));
    else setChangeIds((prev) => [...prev, id]);
  };
  const handleUpdateStatus = (selectedStatus) => {
    return updateSaleOrderStatus({ ids: changeIds, action: selectedStatus.action });
  };
  const handleUpdateStatusResponse = (res, selectedStatus) => {
    if (res.code === 200) {
      let newStatus;
      switch (selectedStatus.action) {
        case 0:
          newStatus = "DEACTIVATED";
          break;
        case 1:
          newStatus = "ACTIVATED";
          break;
        case 4:
          setChangeIds([]);
          newStatus = "DELETED";
          break;
        default:
          break;
      }
      dispatch(setDataFromBEState({ saleOrder: data.map((item) => (changeIds.includes(item.id) ? { ...item, status: newStatus } : item)) }));
    }
  };

  return (
    <div>
      <div align="right" style={{ marginBottom: 10, marginTop: 10, backgroundColor: "#b3deff", height: 40 }}>
        <ButtonGroup style={{ height: 40, marginRight: 10 }}>
          <ButtonWithAPICall title="Lấy dữ liệu từ ERP" api={() => postSync({ object: "saleorder" })} variant="outlined">
            <RefreshIcon />
          </ButtonWithAPICall>
          <Button onClick={() => setOpen((prev) => !prev)}>
            <Tooltip title="Thư mục">
              <SearchIcon />
            </Tooltip>
          </Button>
        </ButtonGroup>
      </div>
      <Collapse in={isOpen} sx={{ marginBottom: "20px" }}>
        <TextField sx={{ margin: "5px" }} value={filter.id} onChange={(e) => setFilter((prev) => ({ ...prev, id: e.target.value }))} label="ID" />
        <FilterBy
          style={{ display: "inline-flex", margin: "5px", minWidth: 240 }}
          getDataFunc={() => getCustomers({ status: 1 })}
          value={filter.customer || null}
          onChange={(e, newValue) => setFilter((prev) => ({ ...prev, customer: newValue }))}
          label={t("Khách hàng")}
        />
        <CustomDatePicker label={t("Từ ngày")} value={filter.effect_date} onChange={(value) => setFilter((prev) => ({ ...prev, effect_date: value }))} sx={{ minWidth: "200px", margin: "5px" }} />
        <CustomDatePicker label={t("Đến ngày")} value={filter.exp_date} onChange={(value) => setFilter((prev) => ({ ...prev, exp_date: value }))} sx={{ minWidth: "200px", margin: "5px" }} />
        <Autocomplete
          sx={{ display: "inline-flex", minWidth: 200, margin: "5px" }}
          options={statusOptions}
          getOptionLabel={(option) => t(option.label) || ""}
          value={filter.status}
          onChange={(e, newValue) => setFilter((prev) => ({ ...prev, status: newValue }))}
          renderInput={(params) => <TextField {...params} label={t("Trạng thái")} />}
        />
      </Collapse>

      {!data ? (
        <LoadingProgress />
      ) : (
        <TableContainer component={Paper} style={{ width: "98%", marginLeft: 10 }} sx={{ maxHeight: 800 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell style={{ border: "0.5px solid lightgray" }}>ID</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Khách hàng")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Số đơn hàng")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Ngân hàng")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Loại hóa đơn")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Tiền tệ")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Ngày hợp lệ")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Ngày hết hạn")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Ngày cập nhật")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Trạng thái")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>
                  <SelectStatusButton disabled={!changeIds.length} api={handleUpdateStatus} response={handleUpdateStatusResponse} />
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data
                .filter(
                  (item) =>
                    item.id?.toString().contains(filter.id) &&
                    (!filter.customer ? true : filter.customer.id === item.customer_id) &&
                    item.so_no.contains(filter.so_no) &&
                    (filter.status === null ? true : item.status === filter.status.label) &&
                    (!filter.effect_date ? true : moment(filter.effect_date) <= moment(item.effect_date)) &&
                    (!item.exp_date || !filter.exp_date ? true : moment(filter.exp_date) >= moment(item.exp_date))
                )
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).length ? (
                data
                  .filter(
                    (item) =>
                      item.id?.toString().contains(filter.id) &&
                      (!filter.customer ? true : filter.customer.id === item.customer_id) &&
                      item.so_no.contains(filter.so_no) &&
                      (filter.status === null ? true : item.status === filter.status.label) &&
                      (!filter.effect_date ? true : moment(filter.effect_date) <= moment(item.effect_date)) &&
                      (!item.exp_date || !filter.exp_date ? true : moment(filter.exp_date) >= moment(item.exp_date))
                  )
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => (
                    <TableRow key={row.id}>
                      <TableCell style={{ border: "0.5px solid lightgray" }}>{row.id}</TableCell>
                      <TableCell style={{ border: "0.5px solid lightgray" }} align="left">
                        {row.customer_name}
                      </TableCell>
                      <TableCell style={{ border: "0.5px solid lightgray" }}>{row.so_no}</TableCell>
                      <TableCell style={{ border: "0.5px solid lightgray" }} align="left">
                        {row.bank_name}
                      </TableCell>
                      <TableCell style={{ border: "0.5px solid lightgray" }}>{convertInvoiceType(row.invoice_type)}</TableCell>
                      <TableCell style={{ border: "0.5px solid lightgray" }}>{row.currency}</TableCell>
                      <TableCell style={{ border: "0.5px solid lightgray" }}>{row.effect_date && moment(row.effect_date).format("DD/MM/YYYY HH:mm")}</TableCell>
                      <TableCell style={{ border: "0.5px solid lightgray" }}>{row.exp_date && moment(row.exp_date).format("DD/MM/YYYY HH:mm")}</TableCell>
                      <TableCell style={{ border: "0.5px solid lightgray" }}>{row.updated_at && moment(row.updated_at).format("DD/MM/YYYY HH:mm")}</TableCell>
                      <TableCell style={{ border: "0.5px solid lightgray" }}>{t(row.status)}</TableCell>
                      <TableCell style={{ border: "0.5px solid lightgray" }}>
                        <Checkbox disabled={row.status === "DELETED"} checked={changeIds.includes(row.id)} onClick={handleCheckBoxClick.bind(this, row.id)} />
                      </TableCell>
                    </TableRow>
                  ))
              ) : (
                <TableRow>
                  <TableCell colSpan={50}>{t("Không có dữ liệu")}</TableCell>
                </TableRow>
              )}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[10, 25, 100]}
                  count={
                    data.filter(
                      (item) =>
                        item.id?.toString().contains(filter.id) &&
                        (!filter.customer ? true : filter.customer.id === item.customer_id) &&
                        item.so_no.contains(filter.so_no) &&
                        (filter.status === null ? true : item.status === filter.status.label) &&
                        (!filter.effect_date ? true : moment(filter.effect_date) <= moment(item.effect_date)) &&
                        (!item.exp_date || !filter.exp_date ? true : moment(filter.exp_date) >= moment(item.exp_date))
                    ).length
                  }
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      )}
    </div>
  );
};

export default SaleOrder;
